import { Typography } from 'antd';
import { WarningFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

/**
 * INACTIVE — tarif tugab, grace period ham o'tib ketgan va tenant FREE'ga
 * avtomatik downgrade qilingan vaziyat uchun banner. Hero ustida ko'rsatiladi.
 *
 * BE'dan currentPlanStatus === 'INACTIVE' kelganda render qilinadi.
 */
export default function InactiveSubscriptionBanner() {
  const { t } = useTranslation('owner');

  return (
    <div
      role="alert"
      style={{
        position: 'relative',
        borderRadius: 16,
        overflow: 'hidden',
        background:
          'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
        boxShadow: '0 8px 22px rgba(220,38,38,0.32)',
        padding: '14px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <div
        aria-hidden
        style={{
          position: 'absolute',
          top: -40,
          right: -30,
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.10)',
          filter: 'blur(6px)',
          pointerEvents: 'none',
        }}
      />

      <div
        style={{
          position: 'relative',
          width: 38,
          height: 38,
          borderRadius: 12,
          background: 'rgba(255,255,255,0.18)',
          border: '1.5px solid rgba(255,255,255,0.32)',
          color: '#fff',
          fontSize: 18,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          boxShadow: '0 3px 10px rgba(0,0,0,0.18)',
        }}
      >
        <WarningFilled />
      </div>

      <div style={{ position: 'relative', flex: 1, minWidth: 0 }}>
        <Text
          style={{
            display: 'block',
            fontSize: 14,
            fontWeight: 800,
            color: '#fff',
            letterSpacing: -0.2,
            lineHeight: 1.2,
          }}
        >
          {t('subscription.inactiveBanner.title')}
        </Text>
        <Text
          style={{
            display: 'block',
            fontSize: 12,
            color: 'rgba(255,255,255,0.86)',
            marginTop: 2,
            lineHeight: 1.4,
          }}
        >
          {t('subscription.inactiveBanner.subtitle')}
        </Text>
      </div>
    </div>
  );
}
